export type AccountType = "lti" | "saml" | "standalone" | "verity";

export function determineAccountType(account: { id: string }): AccountType {
	if ("lmsUserId" in account) {
		return "lti";
	} else if ("registrationId" in account) {
		return "saml";
	} else if ("expiryDate" in account) {
		return "standalone";
	} else {
		return "verity";
	}
}
